module.exports = __webpack_public_path__ + "static/media/Flow-WeChatPay-ScanQR.956da02e.png";